import React, { Component } from "react";
import Card from "../components/Card";

export default class Skills extends Component {
  render() {
    return (
      <React.Fragment>
        <Card className="content" headerText="Skills">
          <p>
            Organisation and time management are two of my strongest
            characteristics as I like to manage projects and tasks logically and
            always maintain a level of control while making sure I keep up with
            demands. Another prevalent skill is my determination, whenever I
            find something challenging, such as completing university; I
            overcame the aspects I found most difficult to achieve a first-class
            honours degree. Communication is an important part of everyday life,
            both in an educational and in the working environment. No matter
            what situation I am put in, I always make a conscious effort to
            speak clearly and politely, especially during my time working as
            part of a summer camp with students from all over the world. Another
            skill of mine is my passion for learning and I’m constantly trying
            to better myself. This is demonstrated by my time in education but
            also now with the courses, on other programming languages, such as
            React, I do within my free time.
          </p>
        </Card>
      </React.Fragment>
    );
  }
}
